module.exports = __webpack_public_path__ + "static/adobe-959f904f238d6bc1ced7f95ffd45cefa.png";